import styled from "styled-components";
import { Popover, Navbar } from "react-bootstrap";
import { iconClose } from "assets/icons";

export const NavbarContainer = styled(Navbar)`
  /* border-bottom: 1px solid ${({ theme }) => theme.global.border.tertiary}; */
  background: ${({ theme }) => theme.global.bg.auth};
  height: 65px;
  padding: 16px 24px;

  &.fixed-top {
    top: ${({ hasBanner }) => (hasBanner === "true" ? "60px" : "0")};
  }

  .link-logo {
    height: 60px;
    display: flex;
    justify-content: center;

    .main-logo {
      cursor: pointer;
      max-width: 185px;
      height: 26px;
      margin-top: 18px;
      padding: 0px 0px 0px 0.5em;
    }
  }

  .nav-title {
    position: absolute;
    left: 255px;
    text-transform: capitalize;
    font-family: "Public Sans", sans-serif;
    display: flex;
    gap: 16px;

    .title-wrapper {
      display: flex;
      align-items: center;
      gap: 14px;

      .title {
        display: flex;
        align-items: center;
        gap: 25;
        color: #717680;
        font-size: 14px;
        font-weight: 400;
        gap: 8px;
        margin-bottom: 0px;
        cursor: pointer;
      }

      span {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;
        color: #717680;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.065px;
      }
    }

    .back-btn {
      border-radius: 6px;
      border: 1px solid #d5d7da;
      background: rgba(255, 255, 255, 0.6);
      padding: 0px 4px 0px 5px;
      cursor: pointer;
    }
  }

  &.no-sidebar {
    padding: 16px 64px;

    .nav-title {
      left: 64px;
    }
  }

  &.hamburger-icon {
    .hamburger-icon {
      display: none !important;
    }
  }

  .container-fluid {
    padding: 0;
  }

  .hamburger-icon {
    display: none;
    cursor: pointer;
  }
  .new-strategy-btn {
    max-width: 161px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-right: 12px;
  }

  .logged-in-options {
    display: flex;
    gap: 16px;
    margin: 0 5px;
    align-items: center;

    .option {
      border: 1px solid ${({ theme }) => theme.card.border.primary};
      border-radius: 50%;
      background-color: ${({ theme }) => theme.input.bg.secondary};
      height: 32px;
      width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        border: 1px solid ${({ theme }) => theme.card.hover.primary};
      }

      img {
        cursor: pointer;

        &.theme-icon,
        &svg {
          width: 18px;
          height: 18px;
        }
      }
    }

    .btn-invite {
      svg {
        margin-right: 8px;
      }
    }

    .mobile-view {
      display: none;
    }
  }

  .logged-in-wrap {
    display: flex;
    gap: 49px;
    cursor: pointer;
    margin-left: 6px;
    align-items: center;
    border-radius: 35px;
    background: rgba(246, 245, 248, 0.65);
    padding: 8px 12px;
    transition: all 0.2s ease;

    &.active {
      background: rgba(246, 245, 248, 0.5);
      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    }

    .logged-in-user-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .logged-in-user {
      color: ${({ theme }) => theme.global.color.highlights};
      font-weight: 500;
      border-radius: 50%;
      height: 32px;
      width: 32px;
      justify-content: center;
      display: flex;
      align-items: center;
      border: 1px solid ${({ theme }) => theme.card.border.quaternary};

      img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }

    .user-name-display {
      color: ${({ theme }) => theme.global.color.bodyColor};
      font-size: 14px;
      font-weight: 500;
      margin-right: 4px;
    }

    img {
      svg {
        stroke: #717184;
      }
    }
  }

  .navbar-toggler-icon {
    cursor: pointer;
  }

  .navbar-nav {
    align-items: center;

    .username {
      padding: 0.5rem;
    }
    .dropdown-toggle {
      .thumbnail-image {
        padding: 2px;
      }
    }
    .dropdown-toggle:focus {
      outline: 0;
    }
    .dropdown-menu {
      padding: 0px !important;
      background: ${({ theme }) => theme.dropdown.bg.primary} !important;
      border: none !important;
      min-width: 111px;
      margin-top: 10px;
      margin-right: 7px;

      &::after {
        display: none;
      }
      .dropdown-item {
        text-align: left;
        padding: 0.6rem 1.5rem;
        font-size: 15px;
      }
    }
  }

  .strategy-image-wrapper {
    width: 30px;
    height: 30px;
    svg {
      font-size: 30px;
      margin-right: 5px;
    }
  }

  .icon-notification {
    cursor: pointer;
    width: 18px;
    height: 18px;

    & > path {
      opacity: ${({ theme }) => theme.image.opacity};
    }
  }

  .signin-btn {
    background: transparent;
    border: 1px solid ${({ theme }) => theme.button.font.quinary};
    margin-right: 10px;
    width: 104px;
    height: 40px;
    padding: 5px;
    font-size: 14px !important;
    color: ${({ theme }) => theme.button.font.quinary};
    :hover {
      color: ${({ theme }) => theme.button.font.primary};
    }
  }

  .signup-btn {
    border: 1px solid ${({ theme }) => theme.button.bg.primary};
    font-size: 16px !important;
    width: 104px;
    height: 40px;
    background: ${({ theme }) => theme.button.bg.primary};
    padding: 5px;
    font-size: 14px !important;
  }

  @media screen and (max-width: 517px) {
    .nav-title.title-text {
      p,
      span {
        display: none;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 10px;

    &.fixed-top {
      top: ${({ hasBanner }) => (hasBanner === "true" ? "95px" : "0")};
    }
    .logged-in-wrap {
      gap: 5px;
    }

    .nav-title {
      left: 50px;

      .title-wrapper {
        display: none;
      }
    }
    &.no-sidebar {
      padding: 10px 20px;

      .nav-title {
        left: 20px;
        gap: 4px;

        .title-wrapper {
          display: none;
        }
      }
    }

    .nav-title.title-text {
      svg {
        margin: 0px;
      }
    }

    .hamburger-icon {
      display: block !important;
    }

    .main-logo {
      width: 120px;
    }

    .search-wrapper {
      padding-top: 0;
      margin: 0 5px;

      .search-icon {
        left: 6px;
        top: 9px;
        height: 18px;
        width: 20px;
      }

      .search-input {
        width: 150px;
        height: 35px;
        padding: 0 10px 0 30px;
        font-size: 14px;

        &::placeholder {
          font-size: 12px;
        }
      }
    }
  }

  @media (max-width: 375px) {
    .main-logo {
      width: 100px;
    }
  }

  @media screen and (max-width: 500px) {
    .title {
      &.hide {
        display: none;
      }
    }
  }

  @media screen and (max-width: 900px) and (min-width: 768px) {
    .nav-title.title-text {
      p,
      span {
        display: none;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .nav-title .title {
      font-size: 14px;
    }

    .search-wrapper {
      margin-right: 0px;

      .search-subwrapper {
        display: flex;
        gap: 10px;
      }
    }
  }
`;

export const SearchContainer = styled.div`
  .search-input {
    width: 320px;
    border: 1px solid #d5d7da;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgba(10, 13, 18, 0.05);
    color: #181d27;
    font-family: "Public Sans", sans-serif;
    font-size: 16px;
    font-weight: 500;
    &::placeholder {
      color: #717680;
      font-family: "Public Sans", sans-serif;
      font-size: 16px;
    }
  }
`;

export const TransferFundsButton = styled.button`
  border-radius: 8px;
  padding: 8.5px 14px;
  border: 1px solid #d5d7da;
  font-size: 14px;
  background: #fff;
  color: rgba(10, 13, 18, 0.7);
  font-family: "Aeonik", sans-serif;
`;

export const SearchPopover = styled(Popover)`
  &.popover {
    color: ${({ theme }) => theme.global.extraInfo.font.color};
    border-radius: 8px;
    min-width: 320px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #fff;
    z-index: 1100;
    box-shadow: 0 12px 16px -4px rgba(10, 13, 18, 0.08),
      0 4px 6px -2px rgba(10, 13, 18, 0.03),
      0 2px 2px -1px rgba(10, 13, 18, 0.04);

    .popover-header,
    .popover-body {
      box-shadow: none;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      padding: 0;

      .tab-category-wrapper {
        display: flex;
        justify-content: space-between;

        .btn-close {
          background: url("${iconClose}") center/1em auto no-repeat;
          position: absolute;
          right: 16.8px;
          top: 16.8px;
          opacity: 1;
          outline: none;
          z-index: 1;

          :hover {
            color: ${({ theme }) => theme.modal.button.close.color};
          }
          &:focus {
            box-shadow: none;
          }
        }
      }

      .search-list {
        max-height: 600px;
        overflow: auto;
        padding: 0.5rem;

        .heading {
          margin-top: 18px;
          font-size: 14px;
          font-weight: 400;
          border-bottom: 1px solid ${({ theme }) => theme.card.border.primary};
        }

        .search-item {
          cursor: pointer;
          padding: 5px 3px;
          display: flex;
          align-items: center;
          gap: 12px;

          &:hover {
            background-color: ${({ theme }) => theme.dropdown.bg.secondary};
          }

          .img-box {
            padding: 4px;
            height: 34px;
            width: 34px;

            .avatar-medium {
              width: 25px;
              height: 25px;
            }
            .sb-avatar {
              border-radius: 50%;
              overflow: hidden;
            }
          }

          h2 {
            margin-bottom: 4px;
            max-width: 60px;
            font-size: 15px;
            font-weight: 400;
          }

          /* Stock search item typography and spacing */
          .symbol-text {
            display: flex;
            align-items: center;
            gap: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
          }

          .symbol-title {
            color: #181d27;
            font-family: "Geist", sans-serif;
            font-size: 14px;
            font-weight: 500;
          }

          .symbol-desc {
            color: #535862;
            font-family: "Geist", sans-serif;
            font-size: 12px;
            font-weight: 400;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .strategy-name {
            font-size: 15px;
            font-weight: 500;
          }

          .category {
            background-color: ${({ theme }) => theme.button.bg.primary};
            color: ${({ theme }) => theme.button.font.primary};
            font-weight: 400;
            border-radius: 48px;
            font-size: 12px;
            padding: 3px 10px;
            text-transform: capitalize;
          }

          /* Strategies search item styles */
          &.strategy-search-item {
            .strategy-thumb {
              width: 30px;
              height: 30px;
              border-radius: 6px;
              border: 1px solid rgba(0, 0, 0, 0.05);
              object-fit: cover;
              flex-shrink: 0;
            }

            .strategy-text {
              color: #181d27;
              font-family: "Geist", sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              min-width: 0;
            }
          }
        }

        .more-data-loading {
          text-align: center;
          margin-top: 5px;
          height: 20px;
        }
      }
    }

    .popover-arrow {
      display: none;
    }
  }

  @media (max-width: 768px) {
    &.popover {
      max-height: 500px;
      min-width: 357px;
      overflow: auto;
      box-shadow: 0px 0px 20px rgba(51, 54, 55, 0.3);

      .strategy-search-item {
        justify-content: space-between;

        .strategy-name {
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }
      }

      .popover-body .search-list .search-item {
        font-size: 14px;

        .strategy-name {
          font-size: 14px;
        }
      }
    }
  }
`;

export const AccountDropdownPopover = styled(Popover)`
  &.popover {
    width: 232px;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    background: #fafafa;
    box-shadow: 0 12px 16px -4px rgba(10, 13, 18, 0.08),
      0 4px 6px -2px rgba(10, 13, 18, 0.03),
      0 2px 2px -1px rgba(10, 13, 18, 0.04);
  }

  .popover-body {
    padding: 0;

    .user-details {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${({ theme }) => theme.global.color.bodyColor};
      padding: 0px 14px;

      img {
        border-radius: 50%;
        width: 33px;
        height: 33px;
      }

      .user-name {
        font-weight: 500;
        font-size: 14px;
        color: #181d27;
        font-family: "Public Sans", sans-serif;
      }

      .user-email {
        font-weight: 400;
        font-size: 14px;
        max-width: 150px;
        color: #535862;
        text-overflow: ellipsis;
        font-family: "Public Sans", sans-serif;
      }

      .user-icon {
        color: ${({ theme }) => theme.global.color.highlights};
        font-weight: 500;
        border-radius: 50%;
        height: 35px;
        width: 35px;
        justify-content: center;
        display: flex;
        align-items: center;
        border: 1px solid ${({ theme }) => theme.card.border.quaternary};
      }
    }

    .sign-out {
      color: #414651;
      font-family: "Public Sans", sans-serif;
      font-size: 14px;
      font-weight: 600;
      margin-top: 10px;

      .item {
        padding: 10px 16px;

        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        border-radius: 8px;

        &:hover {
          background: rgba(10, 13, 18, 0.04);
        }
      }
    }

    button {
      width: 100%;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 10px;
    }

    ul {
      padding-left: 0;
      margin-bottom: 0;
      border-radius: 12px 12px 16px 16px;
      /* border: 1px solid #e9eaeb; */
      border-bottom: 1px solid #e9eaeb;
      background: #fff;
      margin-bottom: 12px;

      li {
        padding: 14px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;
        color: ${({ theme }) => theme.global.color.bodyColor};
        border-radius: 8px;

        &:hover {
          background: rgba(10, 13, 18, 0.04);
        }
      }
    }
  }

  .popover-arrow {
    display: none;
  }
`;
